import type { HgCountry, HgRegion } from "@/types/taxonomy";
import type { RegionId } from "../../types";

export type RegionOption = { id: RegionId; label: string };
export type CountryOption = { code: string; name: string; regionId?: RegionId };
export type StateOption = { id: string; name: string };

export type GeographyOptions = {
  regions: RegionOption[];
  countries: CountryOption[];
};

const REGION_IDS: RegionId[] = ["AMER", "EMEA", "APAC"];

/** Builds the region/country option lists the geography filter renders from
 * the taxonomy — shared by the authenticated app and the public share page,
 * which additionally narrows them to whatever the segment's own scope allows. */
export function toGeographyOptions(
  countries: HgCountry[],
  regions: HgRegion[]
): GeographyOptions {
  const countryOptions = countries
    .filter((c) => c.alpha2 && c.name)
    .map((c) => ({
      code: c.alpha2,
      name: c.name,
      regionId: c.region?.id as RegionId | undefined,
    }));

  const regionOptions = regions
    .filter((r) => REGION_IDS.includes(r.id as RegionId))
    .map((r) => ({
      id: r.id as RegionId,
      label: `${r.id} (${r.name.toUpperCase()})`,
    }));

  return {
    regions: regionOptions,
    countries: countryOptions,
  };
}
